var __jsx = React.createElement;
import React from "react";
import stl from './FormLabel.module.css';
import { useTranslation } from "@i18n";
var FormLabel = function FormLabel(_ref) {
  var label = _ref.label,
    optional = _ref.optional,
    required = _ref.required;
  var _useTranslation = useTranslation(),
    t = _useTranslation.t;
  return /*#__PURE__*/React.createElement("label", {
    className: stl.label
  }, label, required && /*#__PURE__*/React.createElement("span", null, "*"), optional && /*#__PURE__*/React.createElement("span", {
    className: stl.note
  }, t("optional", {
    ns: "web_common"
  })));
};
export default FormLabel;